import { HashMessageData } from '@app-types/common/common.types';

export const prepareHashMessage = (data: HashMessageData) =>
  Object.entries(data)
    // @ts-ignore
    .sort(([a], [b]) => a - b)
    .map(([key, val]) => `${key}_${val}`)
    .join('__');
